import { DateTime } from 'luxon'

export const globalVariablesMixin = {
  data: function () {
    return {
      conf,
      user,
      roles,
      isLogged,
      config,
      locale,
      DateTime,
    }
  },
  methods: {
    valueAsArray: function (list) {
      let fields = {}
      for (let name in list) {
        let value = list[name]
        if (name.includes('.')) {
          fields = this.setHierarchy(name, value, fields)
        } else {
          fields[name] = value
        }
      }
      return fields
    },
    setHierarchy: function (name, value, fields) {
      let keys = name.split('.')
      let key = keys.shift()
      if (typeof fields[key] == 'undefined') {
        fields[key] = {}
      }
      if (keys.length === 1) {
        fields[key][keys.shift()] = value
      } else {
        fields[key] = this.setHierarchy(keys.join('.'), value, fields[key])
      }
      return fields
    },
  },
}

export const globalMethodsMixin = {
  methods: {
    setDate: function (data, type) {
      if (data == null) {
        return '-'
      }

      let dateObj

      if (typeof data === 'number') {
        // Handle Unix timestamp format
        dateObj = new Date(data)
      } else if (typeof data === 'string' && data.includes('T')) {
        // Handle ISO 8601 date format
        dateObj = new Date(data)
      } else if (typeof data === 'string') {
        // Handle YYYY-MM-DD date format
        let parts = data.split('-')
        if (parts.length !== 3 || isNaN(parts[0]) || isNaN(parts[1]) || isNaN(parts[2])) {
          return '-'
        }
        let year = parseInt(parts[0], 10)
        let month = parseInt(parts[1], 10) - 1 // JavaScript months are 0-based
        let day = parseInt(parts[2], 10)
        dateObj = new Date(year, month, day)
      } else if (data instanceof Date) {
        dateObj = data
      } else {
        return '-'
      }

      if (isNaN(dateObj.getTime())) {
        return '-'
      }

      return this.$d(dateObj, 'date')
    },
  },
}
